import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { push } from 'connected-react-router';

import { selectUserPermissions } from '../../../store/modules/user-permissions/selectors';
import { useActionDispatcher } from '../../../hooks';
import {
  getUserPermissionsRequest,
  saveUserPermissionsRequest,
  resetCurrentUserPermissions,
} from '../../../store/modules/user-permissions/actions';
import TeamForm from './TeamForm';
import { clipLastSegmentRoute } from '../../../utility/path';

type Props = {
  setIsOpenModal: (value: boolean) => void;
};

const TeamEdit = ({ setIsOpenModal }: Props) => {
  const dispatch = useDispatch();
  const userPermissions = useSelector(selectUserPermissions);
  const { url, params } = useRouteMatch<{id: string; teamId: string}>();

  const userPermissionsId = userPermissions.data?.id;
  const userPermissionsIdRoute = parseInt(params.teamId, 10);

  useEffect(() => {
    if (!userPermissionsId || userPermissionsIdRoute !== userPermissionsId) {
      if (Number.isNaN(userPermissionsIdRoute)) {
        const to = clipLastSegmentRoute(url);
        dispatch(push(to));
      } else {
        dispatch(getUserPermissionsRequest(userPermissionsIdRoute));
      }
    }
  }, [dispatch, userPermissionsIdRoute, userPermissionsId, url]);

  useEffect(() => () => {
    dispatch(resetCurrentUserPermissions());
  }, [dispatch]);

  useEffect(() => {
    if (userPermissions.redirect && userPermissions.data) {
      const to = clipLastSegmentRoute(url);
      dispatch(push(to));
    }
  }, [userPermissions, dispatch, url]);

  const saveUserPermissions = useActionDispatcher(saveUserPermissionsRequest);

  return (
    <TeamForm
      titleSubmit="Send Invite"
      record={userPermissions}
      onSubmit={saveUserPermissions}
      setIsOpenModal={setIsOpenModal}
    />
  );
};

export default TeamEdit;
